<div class="mx-xl mt-md bg-white rounded-md">
  @if (state.isLoading()) {
  <div class="loading-state flex flex-col">
    <app-horus-loading [size]="'S'"> </app-horus-loading>
    <span class="mt-2"> Cargando comunicaciones... </span>
  </div>
  } @else if (state.error()) {
  <div class="error-state">
    <div class="error-text">Error al cargar las comunicaciones</div>
  </div>
  } @else if (state.filteredMessages().length === 0) {
  <div class="no-data-container max-w-[400px] mx-auto">
    <app-horus-message-general
      nameIcon="noDataMessageIcon"
      (action)="clearFilters()"
      size="M"
    >
      <span style="color:#F6D44D; font-size: 14px; line-height: 25px;"
        >Todavía no hay nada por aquí</span
      ><br />
      <span style="font-weight: 400; margin-top: 5px;" class="text-[18px]"
        >Aún no tenemos información sobre
        <strong>&lt;comunicaciones&gt;</strong> en relación a tu
        búsqueda. Prueba usando otros valores.</span
      >
    </app-horus-message-general>
  </div>
  } @else {
  <app-table-list-header title="Comunicaciones">
    <app-multi-select
      [options]="messageTypeOptions"
      [formControl]="typeControl"
      [placeholder]="'Todos'"
      [allSelectedText]="'Todos'"
      [fullWidth]="true"
      label="Tipo de comunicación"
      class="w-[167px]"
      (selectionChange)="onTypeFilterChange($event)"
    >
    </app-multi-select>
  </app-table-list-header>

  <div class="mx-md">
    <app-table [table]="table()" />

    @if (table().getPageCount() > 1) {
    <app-table-pagination [table]="table()" />
    }
  </div>
  }

  <ng-template #descriptionCellTemplate let-context>
    <div class="description-cell">
      <span>{{ context.row.original.templateDescription }}</span>
    </div>
  </ng-template>

  <ng-template #typeCellTemplate let-context>
    <app-message-type-label
      [messageType]="context.row.original.tipoMensaje"
    ></app-message-type-label>
  </ng-template>

  <ng-template #actionsCellTemplate let-context>
    <div class="actions-cell">
      <button
        (click)="viewDetails(context.row.original, $event)"
        class="action-btn"
        title="Ver historial"
        mat-icon-button
      >
        <mat-icon>schedule</mat-icon>
      </button>
      <button
        (click)="resendMessage(context.row.original, $event)"
        class="action-btn"
        title="Reenviar"
        mat-icon-button
      >
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </ng-template>
</div>
